//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      title: 'vue组件-移动端',
      showBack: true
    }
  },
  methods: {
    setHeader() {
      if (this.$route.meta.title) {
        this.title = this.$route.meta.title;
      }
      if (this.$route.meta.noBack) {
        this.showBack = false;
      } else {
        this.showBack = true;
      }
    }
  },
  watch: {
    $route() {
      this.setHeader();
    }
  },
  created() {
    this.setHeader();
  }
}
